import { render, staticRenderFns } from "./split-button.vue?vue&type=template&id=07ac19fe&scoped=true&"
import script from "./split-button.vue?vue&type=script&lang=js&"
export * from "./split-button.vue?vue&type=script&lang=js&"
import style0 from "./split-button.vue?vue&type=style&index=0&id=07ac19fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ac19fe",
  null
  
)

export default component.exports